import React, { useRef } from 'react'
import styled from 'styled-components'

const SentiusTextDiscription = styled.p`
  margin: 35px;
  font-size: 1em;
  transition: 0.5s linear;
`
const BopUpDownArrow = styled.div`
  width: 50px;
  height: 50px;
  background: rgba(215, 215, 215, 0.33);
  border: 2px solid black;
  border-radius: 50%;
  position: absolute;
  bottom: -15px;
  left: calc(50% - 25px);
  z-index: 2;
  transition: 0.5s linear;
  backdrop-filter: blur(3px);
  animation: bounce 2s infinite;
  &:hover {
    background: rgba(215, 215, 215, 0.45);
  }
  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(30px);
    }
    60% {
      transform: translateY(15px);
    }
  }
`
const BoxComponent = styled.div`
  position: relative;
  border: 2px solid black;
  width: 100vw;
  background: black;
  display: flex;
  height: 20px;
  margin-bottom: 40px;
  color: black;
  background: rgba(215, 215, 215, 1);
  border-radius: 20px;
  transition: 0.5s linear;
  ${SentiusTextDiscription} {
    opacity: 0;
    margin: 0;
  }
  &:hover {
    height: auto;
    background: rgba(215, 215, 215, 0.33);
    ${SentiusTextDiscription} {
      opacity: 1;
      margin: 35px;
    }
    ${BopUpDownArrow} {
      opacity: 0;
    }
  }
`

const ArrowImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 5px;
  filter: invert(100%);
  rotate: 90deg;
`

const SentuisInfoBox = ({ children }) => {
  const StayOpenRef = useRef(null)
  const StayOpenTextRef = useRef(null)
  const BopUpDownArrowRef = useRef(null)
  const StayOpen = () => {
    StayOpenRef.current.style.zIndex = '1'
    StayOpenRef.current.style.height = 'auto'
    StayOpenRef.current.style.border = '3px solid rgb(22,198,221)'
    StayOpenTextRef.current.style.opacity = '1'
    StayOpenTextRef.current.style.margin = '35px'

    BopUpDownArrowRef.current.style.display = 'none'
  }

  return (
    <BoxComponent ref={StayOpenRef} onClick={StayOpen}>
      <BopUpDownArrow ref={BopUpDownArrowRef}>
        <ArrowImage src="/images/arrow.png" alt="the image of the arrow that bops up and down" />
      </BopUpDownArrow>
      <SentiusTextDiscription ref={StayOpenTextRef}>{children}</SentiusTextDiscription>
    </BoxComponent>
  )
}
export default SentuisInfoBox
